import axios from '@/lib/axios';
import { PurchaseOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0721. 発注案件管理会計モード切替
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/update_accounting_manual_mode
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  accounting_manual_mode: boolean;
};
const updateAccountingManualMode = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/update_accounting_manual_mode`,
    props
  );
};

export const useUpdateAccountingManualMode = () => {
  return useMutation({
    mutationFn: updateAccountingManualMode,
  });
};
